import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NavigationList from "./NavigationList";
import DetailedStatsTable from "./DetailedStatsTable";
import EditIcon from "@mui/icons-material/Edit";
import cardBackground from "../../backgrounds/card_background.jpg";
import cardNameBackground from "../../backgrounds/card_name_background.png";
import { Fighter } from "../../model/Dto/Fighter";
import Dialogs, { FighterPageDialogType } from "./Dialogs/Dialogs";
import { FighterCardHeader } from "../../components/FighterCard/FighterCardHeader";
import { FighterCard } from "../../components/FighterCard/FighterCard";
import { HighlightedName } from "../../components/HighlightedName";
import { Api } from "../../request/api/api";
import { useNavigate, useParams } from "react-router-dom";
import ContainerWithCircularProgress from "../../components/ContainerWithCircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import { AccessTimeOutlined } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteInjuryDialog from "./Dialogs/DeleteInjuryDialog";
import DeleteSkillDialog from "./Dialogs/DeleteSkillDialog";
import { FighterInjury, Skill } from "../../model/Types";

/*TODO:: 
таблица адвансов
модалка адвансов
функции бойца(поменять статус на убитый, поменять статус на раненый и т.д.)
заметки
модалка скилов
модалка травм
изменение характеристик бойца
менять режим покупки на оружейную дома и уникальное оружие
*/

export default function FighterPage() {
  const [fighter, setFighter] = useState<Fighter | undefined>();
  const [navRefreshKey, setNavRefreshKey] = useState(0);

  const [whichDialogIsOpen, setDialogOpen] =
    useState<FighterPageDialogType>("none");

  const [currentFighterWeaponId, setCurrentFighterWeaponId] = useState<
    string | undefined
  >(undefined);

  const fighterId = useParams().id!;
  const navigate = useNavigate();

  const fetchFighterData = () => {
    Api.fighter.getFighter(fighterId).then((result) => {
      if (result.success) {
        setFighter(result.fighter!);
        setNavRefreshKey((k) => k + 1);
        return;
      }
      navigate("/notFound");
    });
  };

  useEffect(() => {
    fetchFighterData();
  }, [fighterId]);

  const deleteEquipment = (id: string) => {
    Api.fighter
      .removeEquipment(fighterId, id, 1)
      .then((_) => fetchFighterData());
  };

  const deleteWeapon = (id: string) => {
    Api.fighter.removeWeapon(fighterId, id, 1).then((_) => fetchFighterData());
  };

  const [injuryToDelete, setInjuryToDelete] = useState<FighterInjury | null>(null);
  const [deletingInjury, setDeletingInjury] = useState(false);

  const handleDeleteInjury = () => {
    if (!injuryToDelete) return;
    setDeletingInjury(true);
    Api.fighter
      .removeInjury(fighterId, injuryToDelete.id)
      .then(() => fetchFighterData())
      .finally(() => {
        setDeletingInjury(false);
        setInjuryToDelete(null);
      });
  };

  const [skillToDelete, setSkillToDelete] = useState<Skill | null>(null);
  const [deletingSkill, setDeletingSkill] = useState(false);

  const handleDeleteSkill = () => {
    if (!skillToDelete) return;
    setDeletingSkill(true);
    Api.fighter
      .removeSkill(fighterId, skillToDelete.id)
      .then(() => fetchFighterData())
      .finally(() => {
        setDeletingSkill(false);
        setSkillToDelete(null);
      });
  };

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} lg={3}>
          <Stack sx={{ alignItems: { xs: "center", lg: "flex-end" } }}>
            <NavigationList teamId={fighter?.teamId} refreshKey={navRefreshKey} />
          </Stack>
        </Grid>
        <Grid item xs={12} lg={9}>
          <Stack
            spacing={4}
            sx={{ alignItems: { xs: "center", lg: "flex-start" } }}>
            {!fighter ? (
              <Box
                sx={{
                  width: "60%",
                }}>
                <ContainerWithCircularProgress height="200px" />
              </Box>
            ) : (
              <FighterCard>
                <FighterCardContent
                  fighterInfo={fighter}
                  fetchData={fetchFighterData}
                  onOpenCommandHistory={() => setDialogOpen("command-history")}
                  onOpenEditCharacteristic={() => setDialogOpen("edit-characteristic")}
                  onOpenXpDialog={() => setDialogOpen("experience")}
                  onOpenEditInfo={() => setDialogOpen("edit-info")}
                />
              </FighterCard>
            )}
            <Grid container>
              {!fighter ? (
                <Box sx={{ width: "60%" }}>
                  <ContainerWithCircularProgress height="200px" />
                </Box>
              ) : (
                <>
                  <StyledList
                    header="Экипировка"
                    availibleForEdit={fighter.availableForEdit}
                    onClick={() => {
                      setDialogOpen("market");
                    }}>
                    {fighter.weapons.map((item, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={item.name} />
                        {fighter.availableForEdit ? (
                          <>
                            <IconButton
                              onClick={() => {
                                setCurrentFighterWeaponId(item.fighterWeaponId);
                                setDialogOpen("upgrades-and-profiles");
                              }}>
                              <SettingsIcon />
                            </IconButton>
                            <IconButton
                              onClick={() =>
                                deleteWeapon(item.fighterWeaponId)
                              }>
                              <CloseIcon />
                            </IconButton>
                          </>
                        ) : (
                          <></>
                        )}
                        <Chip
                          size="small"
                          sx={{
                            backgroundColor: "#6c757d",
                            color: "white",
                          }}
                          label={item.totalCost}
                        />
                      </ListItem>
                    ))}
                    {fighter.equipment.map((item, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={item.name} />
                        {fighter.availableForEdit ? (
                          <IconButton onClick={() => deleteEquipment(item.id)}>
                            <CloseIcon />
                          </IconButton>
                        ) : (
                          <></>
                        )}
                        <Chip
                          size="small"
                          sx={{
                            backgroundColor: "#6c757d",
                            color: "white",
                          }}
                          label={item.cost}
                        />
                      </ListItem>
                    ))}
                  </StyledList>
                  <StyledList
                    header="Навыки"
                    availibleForEdit={fighter.availableForEdit}
                    onClick={() => {
                      setDialogOpen("skill");
                    }}>
                    {fighter.skills.map((item, index) => (
                      <ListItem
                        key={index}
                        secondaryAction={
                          fighter.availableForEdit ? (
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => setSkillToDelete(item)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          ) : undefined
                        }>
                        <ListItemText
                          primary={
                            <HighlightedName
                              name={item.name}
                              description={item.description}
                            />
                          }
                        />
                      </ListItem>
                    ))}
                  </StyledList>
                  <StyledList
                    header="Травмы"
                    availibleForEdit={fighter.availableForEdit}
                    onClick={() => {
                      setDialogOpen("injury");
                    }}>
                    {fighter.injuries.map((item, index) => (
                      <ListItem
                        key={index}
                        secondaryAction={
                          fighter.availableForEdit ? (
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => setInjuryToDelete(item)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          ) : undefined
                        }>
                        <ListItemText primary={item.name} />
                      </ListItem>
                    ))}
                  </StyledList>
                  <StyledList
                    header="Повышения"
                    availibleForEdit={fighter.availableForEdit}
                    onClick={() => {
                      setDialogOpen("advance");
                    }}>
                    {fighter.levelUps.map((levelUp, index) => (
                      <LevelUpListItem
                        key={levelUp.id}
                        levelUp={levelUp}
                        index={index}
                      />
                    ))}
                  </StyledList>
                </>
              )}
            </Grid>
          </Stack>
        </Grid>
      </Grid>
      {fighter ? (
        <Dialogs
          dialogType={whichDialogIsOpen}
          onClose={() => setDialogOpen("none")}
          fetchData={fetchFighterData}
          fighter={fighter}
          currentFighterWeaponId={currentFighterWeaponId}
        />
      ) : (
        <></>
      )}
      <DeleteInjuryDialog
        open={injuryToDelete !== null}
        injuryName={injuryToDelete?.name ?? ""}
        loading={deletingInjury}
        onClose={() => setInjuryToDelete(null)}
        onConfirm={handleDeleteInjury}
      />
      <DeleteSkillDialog
        open={skillToDelete !== null}
        skillName={skillToDelete?.name ?? ""}
        loading={deletingSkill}
        onClose={() => setSkillToDelete(null)}
        onConfirm={handleDeleteSkill}
      />
    </>
  );
}

interface FighterCardContentProps {
  fighterInfo: Fighter;
  fetchData: () => void;
  onOpenCommandHistory: () => void;
  onOpenEditCharacteristic: () => void;
  onOpenXpDialog: () => void;
  onOpenEditInfo: () => void;
}

function FighterCardContent({ fighterInfo, fetchData, onOpenCommandHistory, onOpenEditCharacteristic, onOpenXpDialog, onOpenEditInfo }: FighterCardContentProps) {
  const [notesValue, setNotesValue] = useState(fighterInfo.notes ?? "");
  const [editingNotes, setEditingNotes] = useState(false);
  const [savingNotes, setSavingNotes] = useState(false);

  useEffect(() => {
    setNotesValue(fighterInfo.notes ?? "");
    setEditingNotes(false);
  }, [fighterInfo.id]);

  const handleSaveNotes = async () => {
    setSavingNotes(true);
    try {
      const ok = await Api.fighter.editFighterNotes(fighterInfo.id, notesValue);
      if (ok) {
        setEditingNotes(false);
        fetchData();
      }
    } finally {
      setSavingNotes(false);
    }
  };

  const handleCancelNotes = () => {
    setNotesValue(fighterInfo.notes ?? "");
    setEditingNotes(false);
  };

  return (
    <>
      <FighterCardHeader
        name={fighterInfo.name}
        rang={fighterInfo.rang}
        totalCost={fighterInfo.totalCost}
        status={fighterInfo.status ?? undefined}
        onEdit={fighterInfo.availableForEdit ? onOpenEditInfo : undefined}
      />
      <ListItem>
        <Stack spacing={2} sx={{ width: '100%' }}>
          <DetailedStatsTable
            baseCharacteristics={fighterInfo.baseCharacteristics}
            totalCharacteristics={fighterInfo.totalCharacteristics}
            totalInjuriesCharacteristics={
              fighterInfo.totalInjuriesCharacteristics
            }
            totalAdvancesCharacteristics={
              fighterInfo.totalAdvancesCharacteristics
            }
            userModificators={fighterInfo.userCharacteristicsDtoModifiers}
            userCostModificator={fighterInfo.userCostModifier}
            exp={fighterInfo.xp}
            lvl={fighterInfo.lvl}
          />
          <Stack
            direction="row"
            spacing={2}
            sx={{ mt: 1, flexWrap: 'wrap' }}
          >
            <Button
              variant="outlined"
              startIcon={<AccessTimeOutlined />}
              onClick={onOpenCommandHistory}
              sx={{ alignSelf: 'flex-start' }}
            >
              История команд ({fighterInfo.commandHistory.length})
            </Button>
            {fighterInfo.availableForEdit && (
              <Button
                variant="outlined"
                onClick={onOpenEditCharacteristic}
                sx={{ alignSelf: 'flex-start' }}
              >
                Изменить характеристики
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={onOpenXpDialog}
              sx={{ alignSelf: 'flex-start' }}
            >
              Опыт бойца
            </Button>
          </Stack>

          {/* Заметки */}
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
              Заметки
            </Typography>
            {fighterInfo.availableForEdit && editingNotes ? (
              <Stack spacing={1}>
                <TextField
                  multiline
                  minRows={3}
                  maxRows={8}
                  fullWidth
                  value={notesValue}
                  onChange={(e) => setNotesValue(e.target.value)}
                  disabled={savingNotes}
                  size="small"
                />
                <Stack direction="row" spacing={1}>
                  <Button size="small" variant="contained" onClick={handleSaveNotes} disabled={savingNotes}>
                    {savingNotes ? "Сохранение..." : "Сохранить"}
                  </Button>
                  <Button size="small" onClick={handleCancelNotes} disabled={savingNotes}>
                    Отмена
                  </Button>
                </Stack>
              </Stack>
            ) : (
              <Stack direction="row" alignItems="flex-start" spacing={1}>
                <Typography variant="body2" sx={{ flex: 1, whiteSpace: "pre-wrap", color: notesValue ? "text.primary" : "text.disabled" }}>
                  {notesValue || "Нет заметок"}
                </Typography>
                {fighterInfo.availableForEdit && (
                  <IconButton size="small" onClick={() => setEditingNotes(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </Stack>
            )}
          </Box>

        </Stack>
      </ListItem>
    </>
  );
}

interface StyledListProps<T> {
  header: string;
  onClick: () => void;
  availibleForEdit: boolean;
  children: React.ReactNode;
}

function StyledList<T>({
  header,
  onClick,
  availibleForEdit,
  children,
}: StyledListProps<T>) {
  return (
    <Grid item xs={6} lg={3}>
      <Stack alignItems="center" sx={{ padding: "3px" }}>
        <Box
          sx={{
            backgroundImage: `url('${cardBackground}')`,
            backgroundSize: "100%",
            backgroundRepeat: "repeat-y",
            width: "100%",
            maxWidth: "300px",
          }}>
          <List
            sx={{
              width: "100%",
              "& .MuiPaper-root": {
                boxShadow: "none",
              },
            }}
            subheader={
              <ListSubheader
                sx={{
                  fontSize: "1.1rem",
                  color: "white",
                  backgroundColor: "transparent",
                  backgroundImage: `url('${cardNameBackground}')`,
                  backgroundPosition: "center",
                  backgroundSize: "120% 120%",
                }}>
                {header}
                {availibleForEdit ? (
                  <IconButton
                    onClick={onClick}
                    sx={{
                      position: "absolute",
                      top: "3px",
                      right: "3px",
                      color: "white",
                    }}>
                    <EditIcon />
                  </IconButton>
                ) : (
                  <></>
                )}
              </ListSubheader>
            }>
            {React.Children.count(children) > 0 ? (
              children
            ) : (
              <ListItem>
                <ListItemText primary="None" />
              </ListItem>
            )}
          </List>
        </Box>
      </Stack>
    </Grid>
  );
}

// Новый компонент для отображения Level Up
interface LevelUpListItemProps {
  levelUp: {
    id: string;
    advancementDtos: Array<{
      id: string;
      name: string;
      cost: number;
    }>;
  };
  index: number;
}

function LevelUpListItem({ levelUp, index }: LevelUpListItemProps) {
  const totalCost = levelUp.advancementDtos.reduce((sum, advancement) => sum + advancement.cost, 0);

  return (
    <ListItem>
      <ListItemText
        primary={
          <Box>
            <Typography variant="body2" component="span">
              Level {index + 1}
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              {levelUp.advancementDtos.map((advancement, advIndex) => (
                <Chip
                  key={advancement.id}
                  label={`${advancement.name} (${advancement.cost} pts)`}
                  size="small"
                  variant="outlined"
                  sx={{
                    mr: 0.5,
                    mb: 0.5,
                    fontSize: '0.7rem',
                    height: '24px'
                  }}
                />
              ))}
            </Box>
          </Box>
        }
        secondary={
          <Typography variant="caption" color="text.secondary">
            Total: {totalCost} pts
          </Typography>
        }
      />
      <Chip
        size="small"
        sx={{
          backgroundColor: "#28a745",
          color: "white",
          fontWeight: "bold",
        }}
        label={`+${totalCost}`}
      />
    </ListItem>
  );
}